'use client';

import type { ReactNode } from 'react';
import { Button } from '../../../../../components/styled/button';
import { Tooltip } from '../../../../../components/tooltip';

type HitlPendingActionButtonProps = {
  label: string;
  tooltip?: string;
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

export function HitlPendingActionButton({
  label,
  tooltip,
  icon,
  onClick,
  disabled,
}: HitlPendingActionButtonProps) {
  return (
    <Tooltip title={tooltip ?? label} openDelay={300}>
      <Button
        variant="outline"
        size="xs"
        aria-label={label}
        onClick={onClick}
        disabled={disabled}
        h="6"
        minH="6"
        px={2}
        gap={1}
        bg="transparent"
        borderColor="border.neutral.muted"
        _hover={{ bg: 'bg.subtle', color: 'fg.default' }}
      >
        {icon}
        {label}
      </Button>
    </Tooltip>
  );
}
